/**
 * Beregningsfunksjoner
 */

/**
 * Beregn tauetrekking-statistikk
 * @param {object} competition - Konkurranseobjekt
 * @param {array} leaderboard - Leaderboard-data
 * @returns {object|null} Statistikk for begge lag
 */
export const calculateTugStats = (competition, leaderboard) => {
  if (!competition || competition.mode !== 'tug_of_war') return null;
  
  // Bruk competitionKm hvis tilgjengelig, ellers 0 (ikke synket enda)
  const teamA = leaderboard
    .filter(l => competition.teams?.[l.id] === 'A')
    .reduce((sum, p) => {
      const km = p.competitionKm?.[competition.id] ?? 0;
      return sum + km;
    }, 0);
    
  const teamB = leaderboard
    .filter(l => competition.teams?.[l.id] === 'B')
    .reduce((sum, p) => {
      const km = p.competitionKm?.[competition.id] ?? 0;
      return sum + km;
    }, 0);
    
  const diff = teamA - teamB;
  const goal = Number(competition.goal) || 100;
  const percent = 50 + (diff / goal * 50);
  
  return { 
    teamA, 
    teamB, 
    percent: Math.max(0, Math.min(100, percent)) 
  };
};

/**
 * Filtrer aktiviteter basert på tidsperiode
 * @param {array} activities - Liste med aktiviteter
 * @param {string} timeFilter - 'week', 'month', eller 'year'
 * @returns {number} Totalt antall kilometer
 */
export const calculateFilteredKm = (activities, timeFilter) => {
  const now = new Date();
  let cutoff = new Date();
  
  if (timeFilter === 'week') {
    cutoff.setDate(now.getDate() - 7);
  } else if (timeFilter === 'month') {
    cutoff.setMonth(now.getMonth(), 1);
  } else if (timeFilter === 'year') {
    cutoff.setFullYear(now.getFullYear(), 0, 1);
  }
  
  return activities
    .filter(a => a.type === 'Run' && new Date(a.date) >= cutoff)
    .reduce((sum, a) => sum + (Number(a.km) || 0), 0);
};

/**
 * Beregn km for en spesifikk datoperiode
 * @param {array} activities - Liste med aktiviteter
 * @param {string|Date} startDate - Startdato
 * @param {string|Date} endDate - Sluttdato
 * @returns {number} Totalt antall kilometer
 */
export const calculateKmForPeriod = (activities, startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  return activities
    .filter(a => {
      const activityDate = new Date(a.date);
      return a.type === 'Run' && activityDate >= start && activityDate <= end;
    })
    .reduce((sum, a) => sum + (Number(a.km) || 0), 0);
};

/**
 * Tildel lag automatisk (balansert)
 * @param {object} teams - Eksisterende lagfordeling
 * @returns {string} 'A' eller 'B'
 */
export const assignTeam = (teams = {}) => {
  const teamA = Object.values(teams).filter(t => t === 'A').length;
  const teamB = Object.values(teams).filter(t => t === 'B').length;
  
  return teamA <= teamB ? 'A' : 'B';
};
